<!-- Author Zhang -->

<template>
  <div>
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t("general.add")}}</el-button>
      </el-form-item>
    </el-form>
    <!-- Table -->
    <el-table :data="tableData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('laborInsInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('laborInsInfo.type')" width=260px align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.type }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('laborInsInfo.amount_labor')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.amount_labor }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('laborInsInfo.amount_emp')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.amount_emp }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date | formatDate }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">{{$t("general.edit")}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">{{$t("general.delete")}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF()">{{$t("general.print")}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview()" plain></el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- Add -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="79%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="139px" class="demo-ruleForm" size="medium">
        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('companyInfo.name')+':'" prop="name1" style="margin-left:50px">
                <el-select v-model="ruleForm.name1" style="margin-right:90px;width: 200px" size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
                  <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.name1"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.type')" prop="type" style="margin-left:50px">
                <el-select v-model="ruleForm.type" style="margin-right:90px;width:200px" :placeholder="$t('general.please_select')" size="mini">
                  <el-option v-for="item in types" :key="item.typesId" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.amount_labor')" prop="amount_labor" style="margin-left:50px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.amount_labor" size="mini" style="width:200px" :placeholder="$t('laborInsInfo.people_example')"></el-input>&nbsp;人
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.amount_emp')" prop="amount_emp" style="margin-left:50px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.amount_emp" size="mini" style="width:200px" :placeholder="$t('laborInsInfo.people_example')"></el-input>&nbsp;人
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.amount_old')" prop="amount_old" style="margin-left:50px">

                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.amount_old" size="mini" style="margin-right:0px;width:200px" :placeholder="$t('laborInsInfo.people_example')"></el-input>&nbsp;人
                <el-button class="el-icon-info" type="text" @click="open1">{{$t("general.hint")}}</el-button>
              </el-form-item>

            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item :label="$t('laborInsInfo.business_overview')" prop="business_overview">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.business_content" size="mini" style="margin-right:0px;width:200px" :placeholder="$t('laborInsInfo.business_overview_example')"></el-input>
                <el-button class="el-icon-info" type="text" @click="open2">{{$t("general.hint")}}</el-button>
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.business_type')" prop="business_type">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.business_type" size="mini" style="margin-right:0px;width:200px" :placeholder="$t('laborInsInfo.business_type_example')"></el-input>
                <el-link type="primary" class="el-icon-info" :underline="false" href="https://www.mhlw.go.jp/bunya/roudoukijun/roudouhokenpoint/dl/saimokuhyou.pdf" target="_blank">業種一覧表</el-link>
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.total_money')" prop="total_money">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.total_money" size="mini" style="width:200px" :placeholder="$t('laborInsInfo.total_money_example')"></el-input>&nbsp;円
              </el-form-item>

              <el-form-item :label="$t('general.date')" prop="date">
                <el-date-picker v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd" style="width:200px" type="date"></el-date-picker>
              </el-form-item>

            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">{{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!-- Edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="79%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="139px" class="demo-ruleForm" size="medium">
        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('companyInfo.name')+':'" prop="name1" style="margin-left:50px">
                <el-select v-model="ruleForm.name1" style="margin-right:90px;width: 200px" size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')">
                  <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.name1"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.type')" prop="type" style="margin-left:50px">
                <el-select v-model="ruleForm.type" style="margin-right:90px;width:200px" :placeholder="$t('general.select')" size="mini">
                  <el-option v-for="item in types" :key="item.typesId" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.amount_labor')" prop="amount_labor" style="margin-left:50px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.amount_labor" size="mini" style="width:200px" :placeholder="$t('laborInsInfo.people_example')"></el-input>&nbsp;人
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.amount_emp')" prop="amount_emp" style="margin-left:50px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.amount_emp" size="mini" style="width:200px" :placeholder="$t('laborInsInfo.people_example')"></el-input>&nbsp;人
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.amount_old')" prop="amount_old" style="margin-left:50px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.amount_old" size="mini" style="width:200px" :placeholder="$t('laborInsInfo.people_example')"></el-input>&nbsp;人
                <el-button class="el-icon-info" type="text" @click="open1">{{$t("general.hint")}}</el-button>
              </el-form-item>

              <!-- <el-form-item label="修正項目番号:" prop="code1" style="margin-left:50px">
                <el-input
                  prefix-icon="el-icon-edit"
                  v-model="ruleForm.code1"
                  size="mini"
                  style="margin-right:70px;width:200px"
                  placeholder="例......"
                ></el-input>
              </el-form-item>-->
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item :label="$t('laborInsInfo.business_overview')" prop="business_overview">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.business_content" size="mini" style="margin-right:0px;width:200px" :placeholder="$t('laborInsInfo.business_overview_example')"></el-input>
                <el-button class="el-icon-info" type="text" @click="open2">{{$t("general.hint")}}</el-button>
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.business_type')" prop="business_type">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.business_type" size="mini" style="margin-right:0px;width:200px" :placeholder="$t('laborInsInfo.business_type_example')"></el-input>
                <el-link type="primary" class="el-icon-info" :underline="false" href="https://www.mhlw.go.jp/bunya/roudoukijun/roudouhokenpoint/dl/saimokuhyou.pdf" target="_blank">業種一覧表</el-link>
              </el-form-item>

              <el-form-item :label="$t('laborInsInfo.total_money')" prop="total_money">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.total_money" size="mini" style="width:200px" :placeholder="$t('laborInsInfo.total_money_example')"></el-input>&nbsp;円
              </el-form-item>

              <el-form-item :label="$t('general.date')" prop="date">
                <el-date-picker v-model="ruleForm.date" size="mini" value-format="yyyy-MM-dd" style="margin-right:90px;width:200px" type="date"></el-date-picker>
              </el-form-item>

              <!-- <el-form-item label="修正項目番号漢字:" prop="code2">
                <el-input
                  prefix-icon="el-icon-edit"
                  v-model="ruleForm.code2"
                  size="mini"
                  style="margin-right:90px;width:200px"
                  placeholder="例......"
                ></el-input>
              </el-form-item>-->
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">{{$t("general.confirm")}}</el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <br />
    <div></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      types: [
        {
          typesId: 1,
          name: this.$t("laborInsInfo.continued"),
        },
        {
          typesId: 2,
          name: this.$t("laborInsInfo.fixed"),
        },
        {
          typesId: 3,
          name: this.$t("laborInsInfo.voluntary"),
        },
      ],
      olds: [
        {
          oldsId: 1,
          name: "0",
        },
        {
          oldsId: 2,
          name: "1",
        },
        {
          oldsId: 3,
          name: "2",
        },
        {
          oldsId: 4,
          name: "3",
        },
        {
          oldsId: 5,
          name: "4",
        },
        {
          oldsId: 6,
          name: "5",
        },
        {
          oldsId: 7,
          name: "6",
        },
        {
          oldsId: 8,
          name: "7",
        },
      ],
      labelPosition: "left",
      ruleForm: {
        id: "",
        type: "",
        code1: "",
        code2: "",
        amount_labor: "",
        amount_emp: "",
        amount_old: "",
        signature: "",
        business_type: "",
        code: "",
        total_money: "",
        date: "",
        name1: "",
        business_content: "",
      },
      rules: {
        name1: [
          {
            required: true,
            message: "入力してください",
            trigger: "blur",
          },
        ],
        amount_labor: [
          {
            required: true,
            message: "入力してください",
            trigger: "blur",
          },
        ],
        amount_emp: [
          {
            required: true,
            message: "入力してください",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "入力してください",
            trigger: "blur",
          },
        ],
        amount_old: [
          {
            required: true,
            message: "入力してください",
            trigger: "blur",
          },
        ],
      },
      tableData: [],
      companyInfo: [],
      companyName: [],
      search: "",
      dialogVisible: false,
      dialogUpdate: false,
      pageSize: 5,
      currentPage: 1,
      total: 0,
      disablePage: false,
    };
  },
  methods: {
    open1() {
      const h = this.$createElement;
      this.$notify({
        title: "高齢者とは",
        message: h(
          "i",
          {
            style: "color: teal",
          },
          "国連の世界保健機関(WHO)の定義では、65歳以上の人のことを高齢者としています。"
        ),
      });
    },
    open2() {
      const h = this.$createElement;
      this.$notify({
        title: "事業概要とは",
        message: h(
          "i",
          {
            style: "color: teal",
          },
          "作業内容（製造工程）、製品名、又は提供されるサービスの内容具体的に記入すること。"
        ),
      });
    },
     preview() {
      var uid = window.localStorage.getItem('LoginUserId');
      window.open("/pdf/労働保険保険関係成立-" + "uid=" + uid + ".pdf");
    },
    printPDF() {
      this.axios
        .post("/LaborInsInfoPDF")
        .then((response) => {
          // console.log(response.data);
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          setTimeout(()=>{this.preview();},700);
          // setTimeout("alert('对不起, 要你久候')", 3000 )
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          console.log(error);
        });
    },
    handleEdit(index, row) {
      this.dialogUpdate = true;
      this.ruleForm = Object.assign({}, row);
    },
    handleDetails(index, row) {
      this.dialogDetails = true;
      this.ruleForm = Object.assign({}, row);
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteLaborInsInfo",
            data: postData,
          })
            .then((response) => {
              this.getPages();
              this.currentPage = 1;
              this.axios
                .post("/pageLaborInsInfo")
                .then((response) => {
                  this.tableData = response.data;
                })
                .catch((error) => {
                  console.log(error);
                });
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed"),
              });
              // console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          this.emptyUserData();
          done();
        })
        .catch((_) => { });
    },
    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage,
      });
      this.axios({
        method: "post",
        url: "/pageLaborInsInfo",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    s1_cancel(ruleForm) {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.emptyUserData();
      this.$refs[ruleForm].resetFields();
    },
    cancel() {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.emptyUserData();

    },
    emptyUserData() {
      this.ruleForm = {
        id: "",
        type: "",
        code1: "",
        code2: "",
        amount_labor: "",
        amount_emp: "",
        amount_old: "",
        signature: "",
        business_type: "",
        code: "",
        total_money: "",
        date: "",
        business_content: "",
      };
    },
    addUser(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            type: this.ruleForm.type,
            code1: this.ruleForm.code1,
            code2: this.ruleForm.code2,
            amount_labor: this.ruleForm.amount_labor,
            amount_emp: this.ruleForm.amount_emp,
            amount_old: this.ruleForm.amount_old,
            signature: this.ruleForm.signature,
            business_type: this.ruleForm.business_type,
            code: this.ruleForm.code,
            total_money: this.ruleForm.total_money,
            date: this.ruleForm.date,
            business_content: this.ruleForm.business_content,
          });
          this.axios({
            method: "post",
            url: "/insertLaborInsInfo",
            data: postData,
          })
            .then((response) => {
              this.axios
                .post("/pageLaborInsInfo")
                .then((response) => {
                  this.tableData = response.data;
                  this.currentPage = 1;
                  this.$message({
                    type: "success",
                    message: this.$t("general.add_completed"),
                  });
                })
                .catch((error) => {
                  console.log(error);
                  this.$message({
                    type: "warning",
                    message: this.$t("general.add_failed"),
                  });
                });
              this.getPages();
              this.emptyUserData();
              this.dialogVisible = false;
              // console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          // console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    updateUser(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.ruleForm.id,
            type: this.ruleForm.type,
            code1: this.ruleForm.code1,
            code2: this.ruleForm.code2,
            amount_labor: this.ruleForm.amount_labor,
            amount_emp: this.ruleForm.amount_emp,
            amount_old: this.ruleForm.amount_old,
            signature: this.ruleForm.signature,
            business_type: this.ruleForm.business_type,
            code: this.ruleForm.code,
            total_money: this.ruleForm.total_money,
            date: this.ruleForm.date,
            business_content: this.ruleForm.business_content,
          });
          this.axios({
            method: "post",
            url: "/updateLaborInsInfo",
            data: postData,
          })
            .then((response) => {
              this.handleCurrentChange();
              this.s1_cancel(ruleForm);
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });
              // console.log(response);
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          // console.log("error submit!!");
          this.$message.error('必須項目が入力されていません');
          return false;
        }
      });
    },
    getPages() {
      this.axios
        .post("/rowsLaborInsInfo")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshData() {
      location.reload();
    },
  },
  created() {
    this.axios
      .post("/pageLaborInsInfo")
      .then((response) => {
        this.tableData = response.data;
      })
      .catch((error) => {
        // this.show = false;
        // this.$message({ type: 'error', message: '開発中です。' });
        // console.log(error);
      });

    this.axios
      .post("/rowsLaborInsInfo")
      .then((response) => {
        this.total = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.axios
      .post("/ListComInfo")
      .then((response) => {
        // console.log(response.data);
        this.companyInfo = response.data;
        // console.log(this.companyInfo);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>


<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  width: 90px;
}

.btn-custom-confirm {
  width: 90px;
}
</style>
<style scoped>
.search_name {
  width: 200px;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}

.style1 {
  margin-right: 145px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/LaborInsInfo.vue